/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import {
  Page,
  Card,
  Button,
  useIndexResourceState,
  IndexTable,
  TextStyle,
  Badge,
} from '@shopify/polaris';
import { useHistory } from 'react-router-dom';

const Order = () => {
  const shop = 'swa-pruebas.myshopify.com';
  const [isloading, setIsLoading] = useState(true);
  const [listProjects, setlistProjects] = useState([]);

  const history = useHistory();

  const resourceName = {
    singular: 'orden',
    plural: 'ordenes',
  };

  const {
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
  } = useIndexResourceState(listProjects);

  const detailOrder = (id) => {
    history.push(`/orderDetail/${id}`);
  };

  const consultOrder = () => {
    window
      .fetch(`${process.env.REACT_APP_BASEURL}/orders?shop=${shop}`, {
        method: 'GET',
      })
      .then((response) => response.json())
      .then((resp) => {
        console.log('entro aqui');
        setlistProjects(resp);
        console.log(resp);
        setIsLoading(false);
      })
      .catch(function err() {
        setIsLoading(false);
      });
  };

  const progressOrder = (id) => {
    setIsLoading(true);
    window
      .fetch(
        `${process.env.REACT_APP_BASEURL}/order-process?shop=${shop}&order=${id}`,
        {
          method: 'GET',
        }
      )
      .then((response) => response.json())
      .then(() => {
        console.log();
        setIsLoading(false);
        consultOrder();
      })
      .catch(function err() {
        setIsLoading(false);
        consultOrder();
      });
  };
  useEffect(() => {
    setIsLoading(true);
    consultOrder();
  }, []);
  return (
    <Page title="Ordenes de Envio">
      <Card>
        <IndexTable
          resourceName={resourceName}
          itemCount={listProjects.length}
          selectedItemsCount={
            allResourcesSelected ? 'Todos' : selectedResources.length
          }
          onSelectionChange={handleSelectionChange}
          loading={isloading}
          headings={[
            { title: 'Pedido' },
            { title: 'Fecha' },
            { title: 'Destinario' },
            { title: 'Total CLP' },
            { title: 'Estado' },
            { title: 'Codigo' },
            { title: '' },
          ]}
        >
          {listProjects.map(
            (
              {
                id,
                number_order,
                fecha,
                cliente,
                total,
                estado,
                response_sendu,
              },
              index
            ) => (
              <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
              >
                <IndexTable.Cell>
                  <TextStyle variation="strong">{number_order}</TextStyle>
                </IndexTable.Cell>
                <IndexTable.Cell>{fecha}</IndexTable.Cell>
                <IndexTable.Cell>
                  {cliente.length > 10 ? `${cliente.slice(0, 10)}..` : cliente}
                </IndexTable.Cell>
                <IndexTable.Cell>{total} CL</IndexTable.Cell>
                <IndexTable.Cell>
                  {estado === '1' ? (
                    <Badge
                      status="success"
                      progress="complete"
                      statusAndProgressLabelOverride="Orden de Envio Generada con exito"
                    >
                      Emitido
                    </Badge>
                  ) : (
                    <Badge
                      status="info"
                      progress="complete"
                      statusAndProgressLabelOverride="A la espera de orden de envio"
                    >
                      No Emitido
                    </Badge>
                  )}
                </IndexTable.Cell>
                <IndexTable.Cell>{response_sendu}</IndexTable.Cell>
                <IndexTable.Cell>
                  {estado === '1' ? (
                    <Button onClick={() => detailOrder(id)}>Ver Orden</Button>
                  ) : (
                    <Button primary onClick={() => progressOrder(id)}>
                      Generar Orden
                    </Button>
                  )}
                </IndexTable.Cell>
              </IndexTable.Row>
            )
          )}
        </IndexTable>
      </Card>
    </Page>
  );
};

export default Order;
